import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../../generic';

import styles from './VendoredPath.module.less';

type Props = {
  path: string;
};

export const VendoredPath: VoidFunctionComponent<Props> = ({
  path,
}) => {
  const isDir = path.endsWith('/');
  return (
    <div className={styles.vendoredPath}>
      <Icon icon={isDir ? icons.folderO : icons.fileO} />
      <div className={styles.path}>{path}</div>
    </div>
  );
};
